export const HAS_CODE_CATEGORY_VALUES = "HAS_CODE_CATEGORY_VALUES";
